import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate,  } from 'react-router-dom';


const UseRecovery = () => {

    const navigate = useNavigate()
    const location = useLocation();
    const condition = location.pathname
    let counter = 0;
    const [loading, setLoading] = useState(false)
    const [dataRecovery, setDataRecovery] = useState([])
    const [urlImage, setUrlImage] = useState('')
    const [services, setServices] = useState([])
    const itemsForPage = 10
    const [currentPage, setCurrentPage] = useState(0)
    const [mostrarNext, setMostrarNext] = useState(true)
  
    function findClinics() {
      if (condition === '/RecoveryHouse' && counter === 0) {
          setLoading(true)
          axios.get("https://sow.pdtcomunicaciones.com/api/recovery-houses",{
            params: {
              "search": ''
            }})
              .then(res => {
                  counter += 1;
                  setLoading(false)
                  setServices(res.data.recovery_houses)
                  setUrlImage(res.data.url)
                  setDataRecovery([...res.data.recovery_houses].splice(0, itemsForPage))
        
              })
              .catch(error => {
                  counter += 1;
                  setLoading(false)
                  console.log(error);
              });
      }
  }
  
  useEffect(() => {
      findClinics();
      
  }, [])
      
  
  const nextHandler = () => {
    const totalElementos = services.length;
  
    const nextPage = currentPage + 1
  
    const firtsIndex = nextPage * itemsForPage
    if (firtsIndex >= totalElementos) {
        setMostrarNext(false)
        return;
    }
  
  
    setCurrentPage(nextPage)
    setDataRecovery([...services].splice(firtsIndex, itemsForPage))
  
  }
  
  const prevHandler = () => {
    setMostrarNext(true)
    const prevPage = currentPage - 1
  
    if (prevPage < 0) return;
  
    const firtsIndex = prevPage * itemsForPage
  
    setDataRecovery([...services].splice(firtsIndex, itemsForPage))
    setCurrentPage(prevPage)
  }
  
  const personalizeFind = (keyWord)=>{
    setLoading(true)
    axios.get("https://sow.pdtcomunicaciones.com/api/recovery-houses",{
            params: {
              "search": keyWord
            }})
              .then(res => {
                  counter += 1;
                  setLoading(false)
                  setServices(res.data.recovery_houses)
                  setUrlImage(res.data.url)
                  setDataRecovery([...res.data.recovery_houses].splice(0, itemsForPage))
        
              })
              .catch(error => {
                  counter += 1;
                  setLoading(false)
                  console.log(error);
              });
  }
  
  const cityFind = (keyWord)=>{
    setLoading(true)
    axios.get("https://sow.pdtcomunicaciones.com/api/recovery-houses",{
            params: {
              "search": keyWord
            }})
              .then(res => {
                  counter += 1;
                  setLoading(false)
                  setServices(res.data.recovery_houses)
                  setUrlImage(res.data.url)
                  setDataRecovery([...res.data.recovery_houses].splice(0, itemsForPage))
        
              })
              .catch(error => {
                  counter += 1;
                  setLoading(false)
                  console.log(error);
              });
  }

  function generateUniqueId() {
    return 'xxxxx-xxxx-4xxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }
  
  const detailRecovery = (house) => {
    navigate(`/RecoveryHouse/${generateUniqueId()}`,{state:{
      name: house.name,
      id: house.id,
      urlImage: urlImage,
      pathImage: house.image,
      stars: house.stars,
      description: house.description,
      address: house.address
    }})
  }
  
  return {
    dataRecovery,
    urlImage,
    currentPage,
    nextHandler,
    prevHandler,
    mostrarNext,
    services,
    loading,
    personalizeFind,
    cityFind,
    detailRecovery
  }
}

export default UseRecovery